import { commaizeInt } from './helpers';

export function calRate(cur, curs) {
  if (cur in curs) {
    return curs[cur];
  }
  return 1;
}

export function convert(price, cur, curs = []) {
  if (cur in curs) {
    const converted = price * curs[cur];
    return ['JPY', 'KRW'].includes(cur)
      ? Math.ceil(converted)
      : parseFloat(converted.toFixed(2));
  }
  return price;
}

export function convertPriceDetail(price, cur, curs) {
  if (cur in curs) {
    const converted = price * curs[cur];
    if (['JPY', 'KRW'].includes(cur)) return commaizeInt(converted);
    return converted.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  return price;
}

export function convertUnit(from, to, price, rates) {
  return price * rates[to] / rates[from]; // eslint-disable-line
}

export function ceil(price, cur, curs = [], isConvert = true) {
  if (cur === 'THB') {
    const frac = (price % 100) >= 90.001 && (price % 100) <= 99 ? 99 : (price % 100);
    return Math.ceil((Math.floor(price / 100) * 100) + frac);
  }
  if (cur in curs && isConvert) {
    if (['JPY', 'RUB'].indexOf(cur) >= 0) {
      return Math.ceil(price * curs[cur] / 10) * 10; //eslint-disable-line
    }
    return Math.ceil(price * curs[cur]);
  }
  if (['JPY', 'RUB'].indexOf(cur) >= 0) {
    return Math.ceil(price / 10) * 10;
  }
  return Math.ceil(price);
}

export function getTopUpPrice(price, cur, curs) {
  const thbPrice = price.bookingFee + price.tax;
  if (cur in curs) {
    if (['JPY', 'KRW'].includes(cur)) {
      return Math.ceil(thbPrice * curs[cur]);
    }
    return parseFloat((thbPrice * curs[cur]).toFixed(2));
  }
  return thbPrice;
}

export function getDefaultCurrency(country) {
  switch (country) {
    case 'AX':
    case 'AD':
    case 'AT':
    case 'BE':
    case 'CY':
    case 'EE':
    case 'FI':
    case 'FR':
    case 'GF':
    case 'TF':
    case 'DE':
    case 'GR':
    case 'GP':
    case 'VA':
    case 'IE':
    case 'IT':
    case 'LU':
    case 'MT':
    case 'MQ':
    case 'YT':
    case 'MC':
    case 'ME':
    case 'NL':
    case 'PT':
    case 'RE':
    case 'BL':
    case 'MF':
    case 'SM':
    case 'SK':
    case 'SI':
    case 'ES':
      return 'EUR';
    case 'IO':
    case 'GG':
    case 'IM':
    case 'JE':
    case 'GS':
    case 'GB':
      return 'GBP';
    case 'CN':
      return 'CNY';
    case 'JP':
      return 'JPY';
    case 'SG':
      return 'SGD';
    case 'AU':
    case 'CX':
    case 'CC':
    case 'HM':
    case 'KI':
    case 'NR':
    case 'NF':
    case 'TV':
      return 'AUD';
    case 'HK':
    case 'MO':
      return 'HKD';
    case 'SE':
      return 'SEK';
    case 'BV':
    case 'NO':
    case 'SJ':
      return 'NOK';
    case 'CH':
    case 'LI':
      return 'CHF';
    case 'RU':
      return 'RUB';
    case 'MY':
      return 'MYR';
    case 'TH':
      return 'THB';
    default: return 'USD';
  }
}
